import { merge } from 'lodash'
import contentSettings from '~/sites/oknanebodvere/content.settings'

const overloadSettings = {}

export default merge(contentSettings, overloadSettings)
